<template>
  <app-page-subsection v-if="data.length > 0" title="Autres événements à venir">
    <event-card-carousel :list="data" />
  </app-page-subsection>
</template>

<script lang="ts" setup>
import EventCardCarousel from "~/business-areas/event/components/event-card-carousel.vue";
import type { EventView } from "~/business-areas/event/composables/event-view.hook";

const properties = defineProps<{
  event: EventView;
}>();

const { data } = useEventList({
  exclude: [properties.event.id],
  from: startOfTomorrow().toDate().toISOString(),
});
</script>
